import React from "react";
import { Container, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import mail from "../assets/icons/icons8-mail-50.png";
import phone from "../assets/icons/icons8-phone-50.png";
import location from "../assets/icons/icons8-location-50.png";
import insta from "../assets/icons/icons8-instagram-50.png"
import { isCollectorEnabled } from "../../../helpers/collectorSession";

const Footer = () => {
  return (
    <div className="footer" id="Contact">
      <Container className="footer-container">
        <Grid container spacing={2} >
          <Grid item xs={12} md={6} lg={4}>
            <ul>
              <li>
                <Link to="/home">
                  <div className="footer-hastakala-logo">
                    <span className="sp1">Hastkala</span>{" "}
                    <span className="sp2">Paramanak</span>
                    <p>Supporting the makers, Protecting the buyers</p>
                  </div>
                </Link>
              </li>
              <li>
                <div className="pt-2 content">
                  Product records, certificates, and tags for handmade work —
                  and a collection for the pieces people keep.
                </div>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <ul>
              <li>Quick links</li>
              <li><Link to="/studio">Studio</Link></li>
              {isCollectorEnabled() && (
                <li><Link to="/collectors">My Collection</Link></li>
              )}
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/home#contact">Contact</Link></li>
            </ul>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <ul>
              <li>Important links</li>
              <li><Link to="/terms-and-conditions" target="_blank">Terms of services</Link></li>
              <li><Link to="/privacy-policy" target="_blank">Privacy Policy</Link></li>
              <li><a href="https://wa.link/5edo3n" target="_blank" rel="noreferrer">Support</a></li>
            </ul>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ul className="contact-us">
              <li>Contact Us</li>
              <li><img src={mail} width={20} height={20} alt="Email"/>kunal@hastkalapramanak.in</li>
              <li><img src={phone} width={20} height={20} alt="Phone"/>+91 8935017347</li>
              <li><img src={location} width={20} height={20} alt="Location"/>19th Main Rd, Vanganahalli, Sector 4, HSR Layout, Bengaluru, Karnataka 560102</li>
              <li><a href="https://www.instagram.com/hastkalapramanak/" target="_blank" rel="noreferrer"><img src={insta} width={20} height={20} alt="Instagram"/>Instagram</a></li>
            </ul>
          </Grid>
        </Grid>
      </Container>
      <div className="allrights">© {new Date().getFullYear()} HastkalaPramanak. All rights reserved.</div>
    </div>
  );
};

export default Footer;
